import ClaimGrid from "@/features/claims/ClaimGrid";

export default function Claim() {
  return (
    <>
      <ClaimGrid/>
    </>
  );
}
